module.exports = __webpack_public_path__ + "img/w20b.f5505ef8.jpg";